import { render, staticRenderFns } from "./AdminTimezone.vue?vue&type=template&id=5bca6a0e"
import script from "./AdminTimezone.vue?vue&type=script&lang=js"
export * from "./AdminTimezone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports